$(function () {


  var searchFestivalsGerer = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    //prefetch: '../data/films/post_1960.json',
    remote: {
      url: '/festivals/recherche/%QUERY.json?gerer=0',
      wildcard: '%QUERY'
    }
  });
  var searchFestivals = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    //prefetch: '../data/films/post_1960.json',
    remote: {
      url: '/festivals/recherche/%QUERY.json?covoiturage=1',
      wildcard: '%QUERY'
    }
  });
  var searchSelectFestivals = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    //prefetch: '../data/films/post_1960.json',
    remote: {
      url: '/festivals/recherche/%QUERY.json?covoiturage=1&selectCov=1',
      wildcard: '%QUERY'
    }
  });

  var covSelectTypeahead = $('.covSelectTypeahead').typeahead(null, {
    name: 'festivalsSelectCov',
    display: 'value',
    limit: 9,
    source: searchSelectFestivals,
    templates: {
      empty: [
        '<div class="empty-message">',
        'Aucun festival trouvé',
        '</div>'
      ].join('\n'),
      suggestion: function (data) {
        return data;
      }
    }
  });

  var festivalSelectTypeahead = $('.festivalSelectTypeahead').typeahead(null, {
    name: 'festivalsSelectCov',
    display: 'value',
    limit: 9,
    source: searchFestivalsGerer,
    templates: {
      empty: [
        '<div class="empty-message">',
        'Aucun festival trouvé',
        '</div>'
      ].join('\n'),
      suggestion: function (data) {
        return data;
      }
    }
  });

  var covTypeahead = $('.covTypeahead').typeahead(null, {
    name: 'festivalsCov',
    display: 'value',
    limit: 9,
    source: searchFestivals,
    templates: {
      empty: [
        '<div class="empty-message">',
        'Aucun festival trouvé',
        '</div>'
      ].join('\n'),
      suggestion: function (data) {
        return data;
      }
    }
  });

  covTypeahead.on('typeahead:render', function () {
    $('.selectFestivalCov').click(function (e) {
      var id_festival = $(this).data('value');

      var contentBox = $(this).find('.selectBoxContent').html();

      $('.festival' + id_festival).remove();
      $('#fFestivalSelect .selectBox').remove();
      $('#fFestivalSelect').append(contentBox);

      $('.festival' + id_festival).append('<input type="hidden" name="fFestival" value="' + id_festival + '">');

      $('#fFestivalSelect').on('click', '.festival' + id_festival + ' .selectClose', function (e) {
        $('.festival' + id_festival).remove();
      });

      $('.typeahead').typeahead('close');

      e.preventDefault();
    });
  });

  $(document).on('click', '.selectFestival .aSelectFestival', function (e) {
    $('#festival_id').val($(this).data('id'));
    $('.selectFestival').hide();
    $('#festivalSelected span').html($(this).data('name'));
    $('#festivalSelected').show();
    $('#festivalNew').hide();
    $('.jsonAddfestival').closest('p').hide();
    e.preventDefault();
  });
  $(document).on('click', '#festivalSelected a.changeFestival', function (e) {
    $('#festival_id').val('');
    $('#festivalSelected').hide();
    $('.selectFestival').show();
    $('.jsonAddfestival').closest('p').show();
    e.preventDefault();
  });
  $(document).on('click', 'a.jsonAddfestival', function (e) {
    $('#festival_id').val('');
    $('#festivalSelected').hide();
    $('#festivalNew').toggle();
    e.preventDefault();
  });
  $(document).on('click', '#fFestivalSelect .selectClose', function (e) {
    $(this).parent('.selectBox').remove();
    $('.selectFestival').removeClass('selectFestivalDisabled');
  });
  $(document).on('click', '#fLocationSelect .selectClose', function (e) {
    $(this).parent('.selectBox').remove();
    $('#fLat').val('');
    $('#fLng').val('');
    $('#fAddress').val('');
  });
  $('.filtresCov .submit').click(function (e) {
    $('.formCov').submit();
    e.preventDefault();
  });

  $('.cov-del').click(function (e) {
    if (confirm('Etes-vous sûr de vouloir supprimer ce covoiturage ?')) {

    } else {
      e.preventDefault();
    }
  });

  if ($('#covDateStart').length) {
    var yesterday = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24);
    $.extend($.fn.pickadate.defaults, {
      monthsFull: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      today: '',
      clear: '',
      close: 'fermer',
      formatSubmit: 'yyyy-mm-dd',
      hiddenSuffix: 'Sub',
      hiddenName: true,
      disable: [
        {from: [1900, 1, 1], to: yesterday}
      ]
    });


    var from_$input = $('#covDateStart').pickadate({
        format: 'dd/mm/yyyy'
      }),
      from_picker = from_$input.pickadate('picker')

    var to_$input = $('#covDateEnd').pickadate({
        format: 'dd/mm/yyyy'
      }),
      to_picker = to_$input.pickadate('picker')

    if (from_picker.get('value')) {
      to_picker.set('min', from_picker.get('select'))
    }
    if (to_picker.get('value')) {
      from_picker.set('max', to_picker.get('select'))
    }

    // from_picker.on('set', function(event) {
    //     if ( event.select ) {
    //         to_picker.set('min', from_picker.get('select'));
    //         if(from_picker.get('select') > to_picker.get('select')) {
    //             to_picker.set('select', null);
    //         }
    //         to_picker.set('select', null);
    //     }
    //     else if ( 'clear' in event ) {
    //         to_picker.set('min', false);
    //     }
    // });
    // to_picker.on('set', function(event) {
    //     if ( event.select ) {
    //         //from_picker.set('max', to_picker.get('select'))
    //     }
    //     else if ( 'clear' in event ) {
    //         //from_picker.set('max', false)
    //     }
    // });
  }

  $('#isAllerRetour').change(function () {
    var value = $(this).val();
    if (value == 0) {
      $('#dateAller').show();
      $('#dateRetour').hide();
    }
    if (value == 1) {
      $('#dateAller').show();
      $('#dateRetour').show();
    }
    if (value == 2) {
      $('#dateAller').hide();
      $('#dateRetour').show();
    }

  });
  $('.typeCovoiturage').change(function () {
    var value = $(this).val();
    if (value == 0) {
      $('.isConducteur').show();
      $('.isPassager').hide();
    } else {
      $('.isPassager').show();
      $('.isConducteur').hide();
    }


  });
  // $( "#dateStart" ).datepicker({
  //     changeMonth: true,
  //     dateFormat: "dd/mm/yy",
  //     maxDate: "{!! $festival->dateEnd !!}",
  //     onClose: function( selectedDate ) {
  //         $( "#dateEnd" ).datepicker( "option", "minDate", selectedDate );
  //     }
  // });
  // $( "#dateEnd" ).datepicker({
  //     changeMonth: true,
  //     dateFormat: "dd/mm/yy",
  //     minDate: "{!! $festival->dateStart !!}",
  //     onClose: function( selectedDate ) {
  //         $( "#dateStart" ).datepicker( "option", "maxDate", selectedDate );
  //     }
  // });
  //
  // $("#fCovStart").geocomplete({
  //     details: ".filtresCov",
  //     detailsAttribute: "data-geo",
  //     componentRestrictions: {country: ["fr"]},
  //     types: ["(cities)"]
  // }).bind("geocode:result", function(event, result){
  //
  //     $('#fLocationSelect').removeClass('hidden');
  //     $('.fAddressSpan').html($('#fAddress').val());
  //
  //     /*var name = result.formatted_address;
  //     var elt = result.address_components;
  //     for(i in elt){
  //         if(elt[i].types[0] == 'name')
  //             alert('name');
  //         if(elt[i].types[0] == 'locality')
  //             $('#ville').val(elt[i].long_name);
  //         if(elt[i].types[0] == 'administrative_area_level_2') {
  //             if(elt[i].long_name == 'Haute-Corse' || elt[i].long_name == 'Corse-du-Sud') elt[i].long_name = 'Corse';
  //             console.log(elt[i].long_name);
  //             console.log(elt[i].long_name.cleanURL());
  //             $('#departement').val(elt[i].long_name.cleanURL()).trigger('change');
  //         }
  //     }
  //     var lat = $('#lat').val();
  //     var lng = $('#lng').val();*/
  //
  //
  // });

});


$(document).ready(function () {
  $(document).on('submit', '.form-contactCov', function (e) {

    e.preventDefault();
    var url = $('#urlContactCov').val();

    var formData = {
      'nom': $('.contactCov-nom').val(),
      'email': $('.contactCov-email').val(),
      'message': $('.contactCov-message').val(),
      '_token': $('input[name=_token]').val()
    };
    // Send the data using post
    var posting = $.ajax({
      url: url,
      type: "post",
      data: formData,
      dataType: 'html',
      success: function (data) {
        //console.log('success');
        //console.log(data);
        $('#modalCovoiturage .modal-body').html(data);

      },
      error: function (data) {
        //console.log('error');
        //console.log(data);

        //console.log('error');
        //console.log(data.responseJSON);
        //$('.has-error').removeClass('has-error');
        //$('.help-block').remove();
        //
        //if (data.responseJSON.nom) {
        //    $('.nom-group').addClass('has-error');
        //    $('.nom-group').append('<div class="help-block">' + data.responseJSON.nom + '</div>');
        //}
        //if (data.responseJSON.email) {
        //    $('.email-group').addClass('has-error');
        //    $('.email-group').append('<div class="help-block">' + data.responseJSON.email + '</div>');
        //}
        //if (data.responseJSON.prenom) {
        //    $('.message-group').addClass('has-error');
        //    $('.message-group').append('<div class="help-block">' + data.responseJSON.message + '</div>');
        //}

      }
    });
    return false;
  });

});